import React from 'react';

export default () => (
  <svg
    width="22"
    height="23"
    viewBox="0 0 22 23"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <title>Trash</title>
    <defs>
      <path id="a" d="M0 22.12h22V0H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path
        d="M18 19.795V6.12H4v13.675c0 .176.148.325.325.325h13.35a.329.329 0 0 0 .325-.325zM7 4h8V2H7v2zm15 .12v2h-2v13.675a2.328 2.328 0 0 1-2.325 2.325H4.325A2.328 2.328 0 0 1 2 19.795V6.12H0v-2h5V0h12v4.12h5z"
        fill="currentColor"
      />
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path
        fill="currentColor"
        mask="url(#b)"
        d="M7.577 16.934h2V9.629h-2zM12.423 16.934h2V9.629h-2z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconDelete.jsx